import { Controller } from "@hotwired/stimulus"

export default class HiddenInputController extends Controller {
  static targets = ["sourceInput", "hiddenInput"]

  update() {
    const value = this.sourceInputTarget.value
    this.hiddenInputTarget.value = value
    this.hiddenInputTarget.dispatchEvent(new Event("change"))
  }
}
